import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import sriLankaImage from '../assets/ashan/Gemini_Generated_Image_zhvu57zhvu57zhvu.png';
import place1 from '../assets/Sri Lanka/800px-Sigiriya_(141688197).jpeg';
import place2 from '../assets/Sri Lanka/Kandy-toothrelictemple-dawn.jpg';
import place3 from '../assets/Sri Lanka/Nine Arch Bridge Sri Lanka.jpg';
import place4 from '../assets/Sri Lanka/Yala-National-Park-1.jpg';
import place5 from '../assets/Sri Lanka/Galle-Fort.webp';
import place6 from '../assets/Sri Lanka/nuwara-eliya-in-sri-lanka.jpg';
import place7 from '../assets/Sri Lanka/Climb-Adams-Peak-Sri-Pada.webp';
import place8 from '../assets/Sri Lanka/800x750-94.jpg';
import place9 from '../assets/Sri Lanka/Bentota-Sri-Lanka-Everything-You-Need-To-Know.jpg';
import place10 from '../assets/Sri Lanka/images.jpeg';
import place11 from '../assets/Sri Lanka/800x750-1.jpg';
import place12 from '../assets/Sri Lanka/Polonnaruwa-Lankathilaka-Feature-Image.jpg';
import place13 from '../assets/Sri Lanka/Unawatuna-Beach-1.jpg';
import place14 from '../assets/Sri Lanka/37.jpg';
import place15 from '../assets/Sri Lanka/udawalawe-national-park.jpg';
import place16 from '../assets/Sri Lanka/01 (2).jpg';
import place17 from '../assets/Sri Lanka/Sigiriya-Uncovered-Delving-into-the-History-Art-and-Legends-800x609-1.jpg';
import place18 from '../assets/Sri Lanka/01.jpg';
import place19 from '../assets/Sri Lanka/Sigriya_rock_from_directly_above_1600x.webp';
import place20 from '../assets/Sri Lanka/temple-sacred-tooth-relic-kandy-sri-lanka.jpg';
import place21 from '../assets/Sri Lanka/Temple-Sacred-Tooth-Relic-kandy-sri-lanka (1).jpg';
import place22 from '../assets/Sri Lanka/Kandy-and-The-Temple.jpg';
import place23 from '../assets/Sri Lanka/little-adams-peak-ella-1440x960.jpg';
import place24 from '../assets/Sri Lanka/POST_PORTRAIT_0002_IMG_9077.webp';
import place25 from '../assets/Sri Lanka/52773560Ravana_Falls.jpg';
import place26 from '../assets/Sri Lanka/hq720.jpg';
import place27 from '../assets/Sri Lanka/image_872e72884c.jpg';
import place28 from '../assets/Sri Lanka/yala-safari-srilanka-economy-tours.jpg.webp';
import place29 from '../assets/Sri Lanka/galle_147f8ef7-7d19-4c30-9069-eb59128e1c2c.webp';
import place30 from '../assets/Sri Lanka/Galle-Fort-Walking-Tour-555x655-1.jpg';
import place31 from '../assets/Sri Lanka/shutterstock-409990654_main_1490260387805.jpeg';
import place32 from '../assets/Sri Lanka/historical-background-in-nuwara-eliya.jpg';
import place33 from '../assets/Sri Lanka/grand-hotel-nuwara-eliya.jpg';
import place34 from '../assets/Sri Lanka/nuwara-eliya-gregory.jpg';
import place35 from '../assets/Sri Lanka/Adams-Peak-Sri-Lanka.webp';
import place36 from '../assets/Sri Lanka/mini-adams-peak-1-7.jpg';
import place37 from '../assets/Sri Lanka/adams-peak-season.jpg';
import place38 from '../assets/Sri Lanka/Michael-at-Worlds-End-View-Horton-Plains-National-Park.jpg';
import place39 from '../assets/Sri Lanka/horton-plains-national.jpg';
import place40 from '../assets/Sri Lanka/Horton-Plains-Nature-Reserve-800x600-1.webp';
import place41 from '../assets/Sri Lanka/Ventura-Beach-Sri-Lanka-Bentota-Beach-2023-2024.jpg';
import place42 from '../assets/Sri Lanka/bentota.jpg';
import place43 from '../assets/Sri Lanka/01 (1).jpg';
import place44 from '../assets/Sri Lanka/1332748-jaffna-library.jpg';
import place45 from '../assets/Sri Lanka/Jaffna-Fort-Jaffna-Sri-Lanka.jpg.webp';
import place46 from '../assets/Sri Lanka/Nainatheevu-in-Jaffna-768x1024.jpeg';
import place47 from '../assets/Sri Lanka/shutterstock-480723793_main_1481633955837.jpeg';
import place48 from '../assets/Sri Lanka/Avukana-Buddha-Statue-Anuradhapua-Ancinet-City.webp';
import place49 from '../assets/Sri Lanka/Anuradhapura-788x537.webp';
import place50 from '../assets/Sri Lanka/UNESCO-World-Heritage-Site-Brahmanic-Monuments-Polonnaruwa-Sri-Lanka-1.jpg';
import place51 from '../assets/Sri Lanka/ThePolonnaruwaVatadage-857341721661428.jpg';
import place52 from '../assets/Sri Lanka/polonnaruwa-640x360.jpg';
import place53 from '../assets/Sri Lanka/Unawatuna-Beach-Sri-Lanka.webp';
import place54 from '../assets/Sri Lanka/20190926_080608-1024x768.webp';
import place55 from '../assets/Sri Lanka/jungle-beach-unawatuna-00-1024x768.webp';
import place56 from '../assets/Sri Lanka/Colombo-city.jpg';
import place57 from '../assets/Sri Lanka/colombo-main-header.jpg';
import place58 from '../assets/Sri Lanka/ee.jpg';
import place59 from '../assets/Sri Lanka/Udawalawe-National-Park-2.jpeg';
import place60 from '../assets/Sri Lanka/12f5bb1d6b11d9f5a5a9b1f64c59bd41-uda-walawe-national-park.jpg';
import place61 from '../assets/Sri Lanka/156-1024x683.jpg';
import place62 from '../assets/Sri Lanka/800x750-9.jpg';
import place63 from '../assets/Sri Lanka/dambulla-cave-temple-architecture-1024x585.jpg';
import place64 from '../assets/Sri Lanka/555x465px-Dambulla_cave_temple_37.webp';
import ceylonTea from '../assets/Sri Lanka/30917a4b2dee144385c49297465d68a3_XL-768x340.jpg';
import spices from '../assets/Sri Lanka/Spices_1200px_23_11_16-1000x600.jpg';
import gems from '../assets/Sri Lanka/Untitled-61.jpg';
import ayurveda from '../assets/Sri Lanka/Ayurveda-Background-gallery-pop-up-(1)-min.jpg';
import handicrafts from '../assets/Sri Lanka/Local-handicraft-workshops-and-shopping-in-Galle.jpg';
import elephants from '../assets/Sri Lanka/Asian-elephant-Elephas-Maximus.webp';
import food from '../assets/Sri Lanka/1689750105634.jpeg';
import festivals from '../assets/Sri Lanka/Three-tuskers-clad-in-illuminated-red-costumes-standing-in-front-of-the-illuminated-white-building-complex-1.jpg';
import coconut from '../assets/Sri Lanka/processed-coconut-products.webp';
import sarees from '../assets/Sri Lanka/E015.webp';
import dances from '../assets/Sri Lanka/DSC_2290-1038x576.jpg';
import stiltFishing from '../assets/Sri Lanka/S4.jpg';
import moonstones from '../assets/Sri Lanka/moonstone-3.jpg';
import cricket from '../assets/Sri Lanka/image_f8c21aee4f.jpg';
import herbs from '../assets/Sri Lanka/Ayurveda-making.jpg';
import masks from '../assets/Sri Lanka/Sri-lankan-Masks.jpg';

const SriLanka = () => {
    const { t } = useTranslation();
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const places = [
        {
            images: [place1, place17, place18, place19],
            name: t('sriLankaSection.places.sigiriyaRockFortress.name'),
            description: t('sriLankaSection.places.sigiriyaRockFortress.description'),
        },
        {
            images: [place2, place20, place21, place22],
            name: t('sriLankaSection.places.templeOfTheTooth.name'),
            description: t('sriLankaSection.places.templeOfTheTooth.description'),
        },
        {
            images: [place3, place23, place24, place25],
            name: t('sriLankaSection.places.ella.name'),
            description: t('sriLankaSection.places.ella.description'),
        },
        {
            images: [place4, place26, place27, place28],
            name: t('sriLankaSection.places.yalaNationalPark.name'),
            description: t('sriLankaSection.places.yalaNationalPark.description'),
        },
        {
            images: [place5, place29, place30, place31],
            name: t('sriLankaSection.places.galleFort.name'),
            description: t('sriLankaSection.places.galleFort.description'),
        },
        {
            images: [place6, place32, place33, place34],
            name: t('sriLankaSection.places.nuwaraEliya.name'),
            description: t('sriLankaSection.places.nuwaraEliya.description'),
        },
        {
            images: [place7, place35, place36, place37],
            name: t('sriLankaSection.places.adamsPeak.name'),
            description: t('sriLankaSection.places.adamsPeak.description'),
        },
        {
            images: [place8, place38, place39, place40],
            name: t('sriLankaSection.places.hortonPlains.name'),
            description: t('sriLankaSection.places.hortonPlains.description'),
        },
        {
            images: [place9, place41, place42, place43],
            name: t('sriLankaSection.places.bentotaBeach.name'),
            description: t('sriLankaSection.places.bentotaBeach.description'),
        },
        {
            images: [place10, place44, place45, place46],
            name: t('sriLankaSection.places.jaffna.name'),
            description: t('sriLankaSection.places.jaffna.description'),
        },
        {
            images: [place11, place47, place48, place49],
            name: t('sriLankaSection.places.anuradhapura.name'),
            description: t('sriLankaSection.places.anuradhapura.description'),
        },
        {
            images: [place12, place50, place51, place52],
            name: t('sriLankaSection.places.polonnaruwa.name'),
            description: t('sriLankaSection.places.polonnaruwa.description'),
        },
        {
            images: [place13, place53, place54, place55],
            name: t('sriLankaSection.places.unawatunaBeach.name'),
            description: t('sriLankaSection.places.unawatunaBeach.description'),
        },
        {
            images: [place14, place56, place57, place58],
            name: t('sriLankaSection.places.colomboCity.name'),
            description: t('sriLankaSection.places.colomboCity.description'),
        },
        {
            images: [place15, place59, place60, place61],
            name: t('sriLankaSection.places.udawalawaNationalPark.name'),
            description: t('sriLankaSection.places.udawalawaNationalPark.description'),
        },
        {
            images: [place16, place62, place63, place64],
            name: t('sriLankaSection.places.dambullaCaveTemple.name'),
            description: t('sriLankaSection.places.dambullaCaveTemple.description'),
        },
    ];

    const famousThings = [
        {
            image: ceylonTea,
            title: t('sriLankaSection.famousThings.ceylonTea.title'),
            description: t('sriLankaSection.famousThings.ceylonTea.description'),
        },
        {
            image: spices,
            title: t('sriLankaSection.famousThings.spices.title'),
            description: t('sriLankaSection.famousThings.spices.description'),
        },
        {
            image: gems,
            title: t('sriLankaSection.famousThings.gems.title'),
            description: t('sriLankaSection.famousThings.gems.description'),
        },
        {
            image: ayurveda,
            title: t('sriLankaSection.famousThings.ayurveda.title'),
            description: t('sriLankaSection.famousThings.ayurveda.description'),
        },
        {
            image: handicrafts,
            title: t('sriLankaSection.famousThings.handicrafts.title'),
            description: t('sriLankaSection.famousThings.handicrafts.description'),
        },
        {
            image: elephants,
            title: t('sriLankaSection.famousThings.elephants.title'),
            description: t('sriLankaSection.famousThings.elephants.description'),
        },
        {
            image: food,
            title: t('sriLankaSection.famousThings.food.title'),
            description: t('sriLankaSection.famousThings.food.description'),
        },
        {
            image: festivals,
            title: t('sriLankaSection.famousThings.festivals.title'),
            description: t('sriLankaSection.famousThings.festivals.description'),
        },
        {
            image: coconut,
            title: t('sriLankaSection.famousThings.coconut.title'),
            description: t('sriLankaSection.famousThings.coconut.description'),
        },
        {
            image: sarees,
            title: t('sriLankaSection.famousThings.sarees.title'),
            description: t('sriLankaSection.famousThings.sarees.description'),
        },
        {
            image: dances,
            title: t('sriLankaSection.famousThings.dances.title'),
            description: t('sriLankaSection.famousThings.dances.description'),
        },
        {
            image: stiltFishing,
            title: t('sriLankaSection.famousThings.stiltFishing.title'),
            description: t('sriLankaSection.famousThings.stiltFishing.description'),
        },
        {
            image: moonstones,
            title: t('sriLankaSection.famousThings.moonstones.title'),
            description: t('sriLankaSection.famousThings.moonstones.description'),
        },
        {
            image: cricket,
            title: t('sriLankaSection.famousThings.cricket.title'),
            description: t('sriLankaSection.famousThings.cricket.description'),
        },
        {
            image: herbs,
            title: t('sriLankaSection.famousThings.herbs.title'),
            description: t('sriLankaSection.famousThings.herbs.description'),
        },
        {
            image: masks,
            title: t('sriLankaSection.famousThings.masks.title'),
            description: t('sriLankaSection.famousThings.masks.description'),
        },
    ];

    const openModal = (place) => {
        setSelectedPlace(place);
        setCurrentImageIndex(0);
    };

    const closeModal = () => {
        setSelectedPlace(null);
        setSelectedImage(null);
        setCurrentImageIndex(0);
    };

    const openImagePreview = (image, index) => {
        setSelectedImage(image);
        setCurrentImageIndex(index);
    };

    const closeImagePreview = () => {
        setSelectedImage(null);
    };

    const nextImage = () => {
        if (selectedPlace && currentImageIndex < selectedPlace.images.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
            setSelectedImage(selectedPlace.images[currentImageIndex + 1]);
        }
    };

    const prevImage = () => {
        if (currentImageIndex > 0) {
            setCurrentImageIndex(currentImageIndex - 1);
            setSelectedImage(selectedPlace.images[currentImageIndex - 1]);
        }
    };

    return (
        <div className="py-16 px-4 sm:px-8 lg:px-16 bg-gradient-to-b from-[#FFFFFF] to-[#F8F1E9] min-h-screen font-customFont">
            {/* Layout for sm and md sizes */}
            <div className="max-w-7xl mx-auto mt-16 lg:hidden text-center">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-[#122C56] mb-12 tracking-tight drop-shadow-md animate-fade-in">
                    {t('sriLankaSection.discoverSriLanka')}
                </h1>
                <div className="mb-8">
                    <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                        <img
                            src={sriLankaImage}
                            alt={t('sriLankaSection.mainImageAlt')}
                            className="w-full max-w-md mx-auto h-80 sm:h-96 md:h-[400px] object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                    </div>
                </div>
                <div className="space-y-6 bg-white p-8 rounded-2xl shadow-lg">
                    <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                        {t('sriLankaSection.introParagraph1', { pearl: t('sriLankaSection.pearlOfIndianOcean') })}
                    </p>
                    <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                        {t('sriLankaSection.introParagraph2')}
                    </p>
                    <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                        {t('sriLankaSection.introParagraph3')}
                    </p>
                    <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                        {t('sriLankaSection.introParagraph4')}
                    </p>
                    <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                        {t('sriLankaSection.introParagraph5')}
                    </p>
                </div>
            </div>

            {/* Layout for lg and larger sizes */}
            <div className="max-w-7xl mx-auto mt-16 hidden lg:block">
                <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md animate-fade-in">
                    {t('sriLankaSection.discoverSriLanka')}
                </h1>
                <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
                    {/* Left Column: Text */}
                    <div className="w-full lg:w-1/2 space-y-6 bg-white p-8 rounded-2xl shadow-lg">
                        <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                            {t('sriLankaSection.introParagraph1', { pearl: t('sriLankaSection.pearlOfIndianOcean') })}
                        </p>
                        <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                            {t('sriLankaSection.introParagraph2')}
                        </p>
                        <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                            {t('sriLankaSection.introParagraph3')}
                        </p>
                        <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                            {t('sriLankaSection.introParagraph4')}
                        </p>
                        <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                            {t('sriLankaSection.introParagraph5')}
                        </p>
                    </div>
                    {/* Right Column: Image */}
                    <div className="w-full lg:w-1/2">
                        <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={sriLankaImage}
                                alt={t('sriLankaSection.mainImageAlt')}
                                className="w-full h-80 sm:h-96 md:h-[600px] object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Attractive Places Section */}
            <div className="max-w-7xl mx-auto mt-16">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md animate-fade-in">
                    {t('sriLankaSection.attractivePlaces')}
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {places.map((place, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transform transition-all duration-500 hover:scale-105 group"
                        >
                            <div className="relative overflow-hidden">
                                <img
                                    src={place.images[0]}
                                    alt={place.name}
                                    className="w-full h-56 sm:h-64 md:h-72 object-cover transition-transform duration-500 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                            </div>
                            <div className="p-6 bg-[#F8F1E9] border-t-2 border-[#C58E2F]">
                                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#122C56] mb-2">{place.name}</h3>
                                <p className="text-gray-700 text-sm sm:text-base line-clamp-3">{place.description}</p>
                                <button
                                    className="mt-4 px-4 py-2 bg-[#C58E2F] text-[#FFFFFF] rounded-lg font-semibold text-sm sm:text-base hover:bg-[#A57324] transition transform hover:scale-105"
                                    onClick={() => openModal(place)}
                                >
                                    {t('sriLankaSection.viewMore')}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal for Place Details */}
            {selectedPlace && (
                <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4 sm:p-8">
                    <div className="bg-white w-full max-w-md sm:max-w-lg md:max-w-4xl rounded-2xl shadow-2xl p-8 relative max-h-[90vh] overflow-y-auto transform transition-all duration-500 scale-95 hover:scale-100 border-t-4 border-[#C58E2F]">
                        <button
                            className="absolute top-4 right-4 bg-gray-200 text-[#122C56] rounded-full p-2 hover:bg-gray-300 transition shadow-md"
                            onClick={closeModal}
                        >
                            ✕
                        </button>
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#122C56] mb-6 text-center drop-shadow-md">
                            {selectedPlace.name}
                        </h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
                            {selectedPlace.images.map((image, index) => (
                                <div key={index} className="relative group">
                                    <img
                                        src={image}
                                        alt={t('sriLankaSection.placeImageAlt', { name: selectedPlace.name, index: index + 1 })}
                                        className="w-full h-48 sm:h-56 md:h-64 object-cover rounded-lg cursor-pointer hover:opacity-90 transition-transform duration-300 group-hover:scale-105 shadow-md"
                                        onClick={() => openImagePreview(image, index)}
                                    />
                                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                                        <span className="text-white text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            {t('sriLankaSection.clickToEnlarge')}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">{selectedPlace.description}</p>
                    </div>
                </div>
            )}

            {/* Modal for Full-Size Image Preview */}
            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4">
                    <div className="relative max-w-4xl max-h-[90vh] bg-white rounded-2xl shadow-2xl p-4 animate-fade-in">
                        <button
                            className="absolute top-4 right-4 bg-gray-200 text-[#122C56] rounded-full p-2 hover:bg-gray-300 transition shadow-md z-10"
                            onClick={closeImagePreview}
                        >
                            ✕
                        </button>
                        {selectedPlace?.images?.length > 1 && (
                            <>
                                <button
                                    onClick={prevImage}
                                    className={`absolute left-4 top-1/2 transform -translate-y-1/2 bg-gray-200 text-[#122C56] rounded-full p-2 hover:bg-gray-300 transition shadow-md ${currentImageIndex === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={currentImageIndex === 0}
                                >
                                    &#8249;
                                </button>
                                <button
                                    onClick={nextImage}
                                    className={`absolute right-4 top-1/2 transform -translate-y-1/2 bg-gray-200 text-[#122C56] rounded-full p-2 hover:bg-gray-300 transition shadow-md ${currentImageIndex === selectedPlace.images.length - 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={currentImageIndex === selectedPlace.images.length - 1}
                                >
                                    &#8250;
                                </button>
                            </>
                        )}
                        <img
                            src={selectedImage}
                            alt={t('sriLankaSection.fullImagePreviewAlt')}
                            className="w-full h-full max-h-[85vh] object-contain rounded-lg"
                        />
                    </div>
                </div>
            )}

            {/* Famous Things Section */}
            <div className="max-w-7xl mx-auto mt-16">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md animate-fade-in">
                    {t('sriLankaSection.famousThingsTitle')}
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {famousThings.map((item, index) => (
                        <div
                            key={index}
                            className="relative bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transform transition-all duration-500 hover:scale-105 group"
                        >
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-56 sm:h-64 md:h-72 object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                            <div className="p-6 bg-[#F8F1E9] border-t-2 border-[#C58E2F]">
                                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#122C56] mb-2">{item.title}</h3>
                                <p className="text-gray-700 text-sm sm:text-base line-clamp-3">{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SriLanka;